export default class Debug
{
    constructor(_options)
    {
        this.debug = false

        // Values with debug off
        this.showStats = false
        this.showLightHelper = false
        this.showLightShadowHelper = false
        this.enableLogs = false
        this.overrideMaterials = false

        /**
         * Values with debug on --------------------------------------------------------------
         */
        if(this.debug)
        {
            this.showStats = true
            this.showLightHelper = false
            this.showLightShadowHelper = false
            this.enableLogs = true
            this.overrideMaterials = false
        }
        /**
         * -----------------------------------------------------------------------------------
         */
    }
}
